export const en = {
  volunteerActivityPage: {
    page_title: 'My Volunteering',
    table: {
      title: 'My Volunteer Activity',
      subtext: 'Manage your volunteer activities and submitted hours',
      columns: {
        name: 'Name',
        date: 'Date',
        hours: 'Hours',
        location: 'Location',
        status: 'Status',
        nonprofit: 'Nonprofit',
      },
      status: {
        cancelled: 'Cancelled',
        upcoming: 'Upcoming',
        awaiting_feedback: 'Awaiting Feedback',
        completed: 'Completed',
        submitted: 'Submitted',
        event_in_progress: 'Event In Progress',
        virtual: 'Virtual',
        approved: 'Approved',
        pending: 'Pending',
        denied: 'Denied',
        hours_required: 'Hours Required',
        waitlisted: '#{{position}} on Waitlist',
        none: 'None',
        request_prefix: 'Request',
      },
      community_action: 'Community Action',
      custom_event: "{{userName}}'s custom event",
      outside_hours: '(Outside company hours)',
      empty_state: {
        title: 'No volunteer activities yet',
        description:
          "Looks like you haven't joined any volunteer activities yet.\nGo to your company's dashboard to find a volunteer event!",
      },
      filters: {
        all: 'All',
        purposely: 'Purposely',
        my_hours: 'My Hours',
        type: 'Type',
        status: 'Status',
        type_prefix: 'Type: ',
        status_prefix: 'Status: ',
        start: 'Start',
        end: 'End',
      },
      actions: {
        edit: 'Edit',
        delete: 'Delete',
        give_feedback: 'Give feedback',
        visit_page: 'Visit page',
        view_details: 'View Details',
        add: 'Add',
      },
    },
    search_placeholder: 'Search volunteer activities',
    add_hours_button: 'Add Hours',
    edit_hours_button: 'Edit Hours',
    reservation_hours: {
      subtitle: 'Log your volunteer hours for the event',
      submit: 'Add',
      nonprofit: 'Nonprofit',
      nonprofit_label: 'Nonprofit',
      nonprofit_url: 'Nonprofit Website (optional)',
      location_label: 'Location',
      location_col: 'Location',
    },
    add_hours: {
      title: 'Add Hours',
      description:
        'Add hours for volunteering outside Purposely. Visible to you and company admins for impact tracking.',
      form: {
        required: 'Required',
        confirm_required:
          'I understand that these hours will need to be approved again if edited',
        virtual_notice: 'Either location or virtual event must be selected',
        date: 'Date',
        hours: 'Hours',
        hours_placeholder: 'ex. 3.5',
        virtual_event: 'Virtual',
        location: 'Location',
        location_placeholder: 'ex. Vancouver, BC',
        nonprofit: 'Nonprofit or Charity',
        nonprofit_placeholder: 'ex. Quest Food Exchange',
        cause: 'Cause',
        outside_work_hours: 'Volunteering was done outside of company hours',
        solo_confirmation:
          "I confirm that I'm adding hours for a solo volunteer event",
        submit: 'Submit',
        error_confirmation: 'Please confirm this is a solo event',
        details: 'Details',
        details_hint: "Provide any additional information about your volunteer activity and what you were doing",
      },
      success: 'Hours added',
      confirm_step: {
        title: 'Hours Submitted',
        title_edit: 'Hours Edited',
        description:
          'Your volunteer hours have been successfully submitted.',
        description_review: 'An email will be sent to you once a company administrator has reviewed your submission.',
        description_edit:
          'Your volunteer hours have been successfully edited.',
      },
    },
    details_modal: {
      title: 'Details',
      close: 'Close',
      header:
        'A company administrator has denied your request for the following reason:',
    },
    delete_modal: {
      title: 'Delete Custom Hours',
      message: 'Are you sure you want to delete these custom volunteer hours?',
      confirm: 'Yes, delete',
      cancel: 'Cancel',
      success: 'Your custom hours have successfully been deleted',
      error: 'Unable to delete. Please try again later.',
    },
  },
}
